
import CardWrapper from "../../../../components/wrapper/card/CardWrapper.tsx";
import { IDeviceStateControllerReturn } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateController.ts";
import { ELng } from "../../../../../../../language/main/LanguageKeysEnums.ts";
import { useTranslation } from "react-i18next"
import { appVideos } from "../../../../../../../Media.ts";
import CommonReactGUIElementsFactory from "../../../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory.tsx";
import VideoSlideGallery from "../../../../../../../commonreact/main/components/gallerys/video/VideoSlideGallery.tsx";
import { IModalVideoControllerReturn } from "../../../../../../../commonreact/main/components/modals/modalvideo/ModalVideoController.ts";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  ef: CommonReactGUIElementsFactory;
  mvc: IModalVideoControllerReturn;
}

export const AndroidAppVideoGalleryCard: React.FC<IProps> = (props): JSX.Element => {

  const tag = "AndroidAppPromoCard";
  console.log(tag + "START");

  const { t } = useTranslation();

  const height = props.dsc.screenHeight();
  const nt = "/4: ";
  const tn = " Tutorial";
  const r = 256 / 144;
  const videoItems = [
    { header: tn + " 1" + nt + t(ELng.video_app_harmonical_systems.valueOf()), img: appVideos.app_systems_tn, src: appVideos.app_systems, videoSizeRatio: r },
    { header: tn + " 2" + nt + t(ELng.video_app_progressions.valueOf()), img: appVideos.app_progressions_tn, src: appVideos.app_progressions, videoSizeRatio: r },
    { header: tn + " 3" + nt + t(ELng.video_app_mixer_user.valueOf()), img: appVideos.app_mixer_user_tn, src: appVideos.app_mixer_user, videoSizeRatio: r },
    { header: tn + " 4" + nt + t(ELng.video_app_mixer_progression.valueOf()), img: appVideos.app_mixer_progression_tn, src: appVideos.app_mixer_progression, videoSizeRatio: r },
    { header: t(ELng.video_app_jazz_iivi.valueOf()), img: appVideos.app_jazz_iivi_tn, src: appVideos.app_jazz_iivi, videoSizeRatio: r }
  ];


  return (
    <CardWrapper
      dsc={props.dsc}
      header={<h3>App-Video-Gallery</h3>}
    >
      <div className="flex flex-col">
        <div>
        </div>
        <div className="mt-5">
          <VideoSlideGallery dsc={props.dsc} height={height} videos={videoItems} mvc={props.mvc} />
        </div>
        <div className="mt-5">
        </div>
      </div>
    </CardWrapper>
  )
}